import {HttpErrorResponse} from '@angular/common/http';
import {AuthError, AuthErrorCodes} from '../models/auth-error';
import {throwError} from 'rxjs';
import {LanguageService} from '../../core/services/language.service';

export class PasswordResetErrorSelector {
    lang: string;

    constructor(private languageService: LanguageService) {
        this.lang = this.languageService.getCurrentLanguage().label;
    }

    passwordResetErrorSelector(err: any) {
        let errorCode = AuthErrorCodes.Unknown;
        let message = '';
        if (err.constructor.name === HttpErrorResponse.name) {
            const error = <HttpErrorResponse>err;

            if (error.status === 400) {
                errorCode = AuthErrorCodes.InvalidCredentials;
            }
            if (error.error && error.error.message) {
                message = this.lang === 'EN' ? 'Token has expired, please request a new link.'
                    : 'Der Authentifizierungstoken ist abgelaufen. Bitte fordern Sie einen neuen Link an.';
            }
        }

        return throwError(new AuthError(
            errorCode,
            message,
            err
        ));
    }

    requestPasswordResetErrorSelector(err: any) {
        let errorCode = AuthErrorCodes.Unknown;
        let message = '';
        if (err.constructor.name === HttpErrorResponse.name) {
            const error = <HttpErrorResponse>err;
            if (error.status === 404) {
                errorCode = AuthErrorCodes.InvalidCredentials;
            }
            if (error.error && error.error.message) {
                message = this.lang === 'EN' ?
                    'Couldn\'t reset password. Please make sure to refresh the page and enter the correct email.' :
                    'Das Passwort konnte nicht zurückgesetzt werden. Bitte laden Sie die Seite neu und stellen Sie sicher, dass Sie die richtige E-Mail eingegeben haben.';
            }
        }

        return throwError(new AuthError(
            errorCode,
            message,
            err
        ));
    }
}
